import { useState } from 'react';
import { AutoGraphOutlined as Graph } from '@mui/icons-material';

import '../../../../../../../components/Graph/graph.scss';
import { CustomAlert, CustomButton, PopupNavigation } from '../../../../../../../shared/uiComponents';
import GraphTargetContent from './graphTargetContent';
import {
	TargetProperties,
	TargetTypes,
} from '../../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';
import { ChartSimpleIcon } from '../../../../../../../shared/Assets/svgIcons';

interface GraphsTargetProps {
	allTargets?: TargetProperties[];
	currentIndex?: number;
	isIcon: boolean;
	mobileButton?: boolean;

	targetId: string;
	targetName: string;
	type: TargetTypes;
}

const GraphsTarget = ({
	targetId,
	targetName,
	type,
	isIcon,
	allTargets,
	currentIndex = 0,
	mobileButton,
}: GraphsTargetProps) => {
	const [openGraphs, setOpenGraphs] = useState<boolean>(false);
	const [activeIndex, setActiveIndex] = useState<number>(currentIndex);

	const hasNavigation = allTargets && allTargets.length > 1;
	const currentTarget = hasNavigation ? allTargets[activeIndex] : null;
	const displayTargetId = currentTarget?.id || targetId;
	const displayTargetName = currentTarget?.name || targetName;
	const displayType = currentTarget?.type?.id || type;

	const handlePrevious = () => {
		if (activeIndex > 0) {
			setActiveIndex(activeIndex - 1);
		}
	};

	const handleNext = () => {
		if (allTargets && activeIndex < allTargets.length - 1) {
			setActiveIndex(activeIndex + 1);
		}
	};

	const handleClose = () => {
		setOpenGraphs(false);
		// Reset to initial index when closing
		setActiveIndex(currentIndex);
	};

	return (
		<>
			{isIcon ? (
				<Graph onClick={() => setOpenGraphs(true)} className="graph-icon" />
			) : mobileButton ? (
				<div
					className="targetActionButton"
					onClick={(e) => {
						e.stopPropagation();
						setOpenGraphs(true);
					}}
				>
					<ChartSimpleIcon />
				</div>
			) : (
				<CustomButton
					iconOnly={<ChartSimpleIcon />}
					onClick={() => setOpenGraphs(true)}
					buttonType="tertiary"
					sizeType="md"
				/>
			)}
			<CustomAlert
				title={displayTargetName}
				onClose={handleClose}
				open={openGraphs}
				Content={() => (
					<>
						<GraphTargetContent
							targetId={displayTargetId}
							type={displayType as TargetTypes}
							targetName={displayTargetName}
						/>
						{hasNavigation && (
							<PopupNavigation
								currentIndex={activeIndex}
								totalCount={allTargets.length}
								onPrevious={handlePrevious}
								onNext={handleNext}
							/>
						)}
					</>
				)}
			/>
		</>
	);
};

export default GraphsTarget;
